import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import { getBaseUrl } from '../getBaseUrl'; // Ensure correct path and data
import { getBaseUrl } from "../config";
import { getIncomingEmailFromToken } from "../../utils/common";

const baseUrl = getBaseUrl();
// Async thunk for generating a token
export const generateToken = createAsyncThunk(
  "generateToken",
  async (payload, { rejectWithValue }) => {
    try {
      const outgoingEmail = String(payload || "").trim();
      const incomingEmail = getIncomingEmailFromToken() || outgoingEmail;

      const response = await axios.post(
        `${baseUrl}/token`,
        {
          outgoing_user_email: outgoingEmail,
          incoming_user_email: incomingEmail,
        },
        {
          headers: {
            accept: "application/json",
            "user-email": outgoingEmail,
            "user-emp-id": 123456,
            // 'Content-Type': 'application/json',
            // 'use-case': 'src',
            // 'business-function': 'none',
            // 'user-email':payload.userEmail,
            // // 'Authorization': `Bearer ${payload.token}`,
            // 'client': payload.client ? payload.client :'Pharma Limited'
          },
        },
      );
      // localStorage.setItem('authToken', response.data.access_token);
      // secureLocalStorage.setItem("token",response.data.access_token);
      return response.data.access_token; // Ensure this is the expected structure
    } catch (error) {
      // Logging error details
      console.error("Error details:", error.response);
      return rejectWithValue(
        error.response?.data?.detail || "An error occurred",
      );
    }
  },
);

// Slice for token management
const generateTokenSlice = createSlice({
  name: "generateToken",
  initialState: {
    isLoading: false,
    token: "",
    isError: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateToken.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(generateToken.fulfilled, (state, action) => {
        state.isLoading = false;
        state.token = action.payload; // Ensure action.payload is the correct token
      })
      .addCase(generateToken.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload; // Ensure this matches your error structure
      });
  },
});

export default generateTokenSlice.reducer;
